// Day picker, stage filter chips, device picker, spotlight toggle.

import { store } from "../state/store";
import { MAIN_STAGES, STAGE_COLORS, STAGE_TAG, STAGE_HEADER_WORDS } from "../data/stages";
import { DEVICES } from "../data/devices";

export function mountFilters(host: HTMLElement): void {
  function render() {
    const s = store.get();
    host.innerHTML = `
      <section class="filter-block">
        <h3>Day</h3>
        <div class="day-pills">
          ${[1, 2, 3].map(d => `
            <button class="day-pill ${s.day === d ? "active" : ""}" data-day="${d}">
              ${["FRI · MAY 15", "SAT · MAY 16", "SUN · MAY 17"][d - 1]}
            </button>
          `).join("")}
        </div>
      </section>

      <section class="filter-block">
        <h3>Stages on the wallpaper <span class="filter-count">${s.stages.length}/${MAIN_STAGES.length}</span></h3>
        <div class="stage-chips">
          ${MAIN_STAGES.map(stage => {
            const active = s.stages.includes(stage);
            const c = STAGE_COLORS[stage];
            const [w1, w2] = STAGE_HEADER_WORDS[stage] ?? [stage, ""];
            return `
              <button class="stage-chip ${active ? "active" : ""}"
                      data-stage="${stage}"
                      style="--stage:${c};">
                <span class="stage-dot"></span>
                <span class="stage-name">${w1.toUpperCase()} ${w2.toUpperCase()}</span>
                <span class="stage-tag">${STAGE_TAG[stage]}</span>
              </button>
            `;
          }).join("")}
        </div>
        <div class="filter-actions">
          <button class="ghost-btn" data-action="all-stages">All</button>
          <button class="ghost-btn" data-action="main-only">Main 8</button>
          <button class="ghost-btn" data-action="no-stages">None</button>
        </div>
      </section>

      <section class="filter-block">
        <h3>Device</h3>
        <select class="device-select">
          ${DEVICES.map(d => `<option value="${d.id}" ${s.deviceId === d.id ? "selected" : ""}>${d.label} — ${d.w}×${d.h}</option>`).join("")}
        </select>
      </section>

      <section class="filter-block">
        <h3>Wallpaper options</h3>
        <label class="check-row">
          <input type="checkbox" class="spotlight-check" ${s.spotlightFaves ? "checked" : ""} />
          <span>Spotlight my faves (dim non-faves)</span>
        </label>
      </section>
    `;

    host.querySelectorAll<HTMLElement>(".day-pill").forEach(b => {
      b.addEventListener("click", () => {
        const d = parseInt(b.dataset.day!) as 1 | 2 | 3;
        store.update({ day: d });
      });
    });
    host.querySelectorAll<HTMLElement>(".stage-chip").forEach(b => {
      b.addEventListener("click", () => store.toggleStage(b.dataset.stage!));
    });
    host.querySelectorAll<HTMLElement>("[data-action]").forEach(b => {
      b.addEventListener("click", () => {
        const a = b.dataset.action;
        if (a === "all-stages") store.update({ stages: [...MAIN_STAGES] });
        else if (a === "main-only") store.update({ stages: MAIN_STAGES.slice(0, 8) });
        else if (a === "no-stages") store.update({ stages: [] });
      });
    });
    host.querySelector<HTMLSelectElement>(".device-select")!.addEventListener("change", e => {
      store.update({ deviceId: (e.target as HTMLSelectElement).value });
    });
    host.querySelector<HTMLInputElement>(".spotlight-check")!.addEventListener("change", e => {
      store.update({ spotlightFaves: (e.target as HTMLInputElement).checked });
    });
  }

  store.subscribe(render);
  render();
}
